import { useCallback } from "react";
import { subscribeToPush } from "../lib/pushSubscription";
import { useLocale } from "../lib/i18n";

interface NotificationBannerProps {
  show: boolean;
  onDismiss: () => void;
  onSubscribed: () => void;
}

export function NotificationBanner({ show, onDismiss, onSubscribed }: NotificationBannerProps) {
  const { t } = useLocale();

  const handleNotifyMe = useCallback(async () => {
    try {
      const success = await subscribeToPush();
      if (success) {
        onSubscribed();
      }
    } catch {
      // Subscription failed silently — user can try again
    }
  }, [onSubscribed]);

  if (!show) return null;

  return (
    <div className="fixed bottom-20 left-3 right-3 z-50 mx-auto max-w-[420px] bg-zinc-800/95 backdrop-blur rounded-xl px-4 py-3 shadow-lg animate-slide-up">
      <div className="flex items-center gap-3">
        <span className="text-2xl flex-shrink-0">🔔</span>
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-semibold">{t("notif.title")}</p>
          <p className="text-zinc-400 text-xs">{t("notif.subtitle")}</p>
        </div>
        <button
          onClick={handleNotifyMe}
          className="bg-indigo-500 text-white text-sm font-semibold px-4 py-2 rounded-lg flex-shrink-0"
        >
          {t("notif.button")}
        </button>
      </div>
      <button onClick={onDismiss} className="absolute top-1 right-2 text-zinc-500 text-lg leading-none">&times;</button>
    </div>
  );
}
